/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { IPrescription } from 'app/shared/model/prescription.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';

export interface IPharmacyHistory {
  id?: string;
  tmDate?: number | null;
  noOfDrugs?: number | null;
  excluded?: string | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  billNumber?: string | null;
  bill?: IPharmacyBill | null;
  prescription?: IPrescription;
  pharmacy?: IPharmacy;
}

export const defaultValue: Readonly<IPharmacyHistory> = {
  active: false,
};
